import styled from 'styled-components'

export const B = styled.span`
  font-weight: 600;
`

export const I = styled.span`
  font-weight: 400;
  text-decoration: underline;
`
export const Container = styled.div`
  p {
    font-size: 1em;
    margin-bottom: 1em;
  }
`
